import gsap from 'gsap';
/* PJAX related imports */
import Highway from '@dogstudio/highway';
import Curtain from './transitions/curtain';

export default function(renderers) {
	const H = new Highway.Core({
		renderers: renderers,
		transitions: {
			default: Curtain,
		},
	});

	const links = document.querySelectorAll('.nav li');
	// Query admin bar links and detach them from Highway transitions
	const adminBarLinks = document.querySelectorAll('#wpadminbar a');
	H.detach(adminBarLinks);

	H.on('NAVIGATE_IN', state => {
		let newDocument = state.to.page;

		// Change body classes
		document.body.classList = newDocument.body.classList;

		for (let i = 0; i < links.length; i++) {
			const link = links[i];

			// Clean class
			link.classList.remove('current-menu-item');

			// Active link
			if (link.getElementsByTagName('a')[0].href === location.href) {
				link.classList.add('current-menu-item');
			}
		}

		// Clean Header Scroll inline styles
		let header = document.getElementById('nav');
		gsap.set(header, { clearProps: 'all' });

		// document.getElementById('menu-mobile').innerHTML = newDocument.getElementById('menu-mobile').innerHTML;
	});

	H.on('NAVIGATE_OUT', () => {
		let curtains = document.getElementsByClassName('curtain');
		gsap.set(curtains, { clearProps: 'all' });
	});

	H.on('NAVIGATE_END', state => {
		// Query admin bar links, and new page's admin bar links
		const adminBarLinks = document.querySelectorAll('#wpadminbar a');
		const newAdminBarLinks = state.to.page.body.querySelectorAll('#wpadminbar a');

		// Replace every admin bar link's href value with new value
		for (let i = 0; i < newAdminBarLinks.length; i++) {
			adminBarLinks[i].href = newAdminBarLinks[i].href;
		}

		// Detach admin bar links from Highway transitions
		H.detach(adminBarLinks);
	});
}



// WEBPACK FOOTER //
// ./scripts/highway/setup.js